import Helpers from '@Apis/helpers';
import Constants from '@Apis/constants';

/**
 * @param tenantId
 * @param payload
 * @param poId
 */
class InventoryLocationServices {
  /**
     *
     * @param {*} tenantDepartmentId
     * @param {*} inventoryLocationPath
     * @returns
     */
     getInventoryLocations = async (tenantDepartmentId, inventoryLocationPath, parentLocationId, isStorable, tenantId, departmentId) => {
       let url = `${Constants.INVENTORY_LOCATION}?`;
       if (tenantDepartmentId) url += `tenant_department_id=${tenantDepartmentId}&`;
       if (inventoryLocationPath) url += `inventory_location_name=${inventoryLocationPath}&`;
       if (parentLocationId) url += `inventory_location_parent_id=${parentLocationId}&`;
       if (isStorable) url += `is_storable=${isStorable}&`;
       if (tenantId) url += `tenant_id=${tenantId}&`;
       if (departmentId) url += `department_id=${departmentId}&`;
       const orgInventoryLocation = await Helpers.get({ url });
       return orgInventoryLocation;
     }

     /**
      *
      * @param payload
      * @return {Promise<*>}
      */
     createInventoryLocation = async (payload) => {
       const createInventoryLocation = await Helpers.post({
         url: Constants.INVENTORY_LOCATION,
         data: payload,
       });
       return createInventoryLocation;
     }

     /**
      *
      * @param payload
      * @return {Promise<*>}
      */
     updateInventoryLocation = async (payload) => {
       const updateInventoryLocation = await Helpers.put({
         url: Constants.INVENTORY_LOCATION,
         data: payload,
       });
       return updateInventoryLocation;
     }

     /**
     *
     * @param payload
     * @return {Promise<*>}
     */
     deleteInventoryLocation = async (payload) => {
       const deleteInventoryLocation = await Helpers.delete({
         url: Constants.INVENTORY_LOCATION,
         data: payload,
       });
       return deleteInventoryLocation;
     }
}
export default new InventoryLocationServices();
